import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//UI
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import useStyles from "../../../styles/Common";
import "../../../styles/common.css";
import * as XLSX from "xlsx-js-style";

//ACTION
import { fetchPassengerDetailsListCustom, initialStatePassengerDetailsListCustom } from "../../../../redux/slices/custom/reservations/cruise/passengerDetails/customPassengerDetailsList.slice";
//RESOURCE
import HeadDetail from "../../../../components/headDetail";
import { scrollToTop } from "../../../resources/utils";
import { Button, Message } from "semantic-ui-react";

export default function PassengerDetailList() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { cruise_id } = useParams();
  const passengerByCruiseStateCustom = useSelector(
    (state) => state.customPassengerDetailsList);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPassengerDetailsListCustom(cruise_id));
    scrollToTop();
    return () => {
      dispatch(initialStatePassengerDetailsListCustom());
    };
  }, [dispatch, cruise_id]);

  if (passengerByCruiseStateCustom.fetching) {
    return <CircularProgress />;
  }

  const handleGenerateExcel = () => {

    const MAX_ROWS = 16;

    const data = Array.from({ length: MAX_ROWS }, (_, index) => {
      const passenger = passengerByCruiseStateCustom.passengers[index];

      if (!passenger) {
        return {
          APELLIDOS: "",
          NOMBRES: "",
          "N DOCUMENTO": "",
          "FECHA DE NACIMIENTO": "",
          NACIONALIDAD: "",
          "FECHA IDA": "",
          "N DE VUELO": "",
          RUTA: "",
          RECORD: "",
        };
      }

      return {
        APELLIDOS: passenger.last_name?.toUpperCase() || "",
        NOMBRES: passenger.first_name?.toUpperCase() || "",
        "N DOCUMENTO": passenger.identification || "",
        "FECHA DE NACIMIENTO": passenger.passenger_birthdate,
        NACIONALIDAD: passenger.country || "",
        "FECHA IDA": passenger.flight_time,
        "N DE VUELO": passenger.flight_name || "",
        RUTA: passenger.routes,
        RECORD: "",
      };
    });


    const worksheet = XLSX.utils.json_to_sheet(data);

    worksheet["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 17 },
      { wch: 17 },
      { wch: 18 },
      { wch: 18 },
      { wch: 15 },
      { wch: 25 },
      { wch: 15 },
    ];

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    const borderStyle = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {

        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });

        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: row === 0 ? { bold: true } : {},
          alignment: {
            horizontal: row === 0 ? "left" : "center",
            vertical: "center",
          },
          border: borderStyle,
        };
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pasajeros");

    XLSX.writeFile(workbook, "listapasajeros.xlsx");
  };

  return (
    <>
      {passengerByCruiseStateCustom.error ? (
        <Message negative content={t(passengerByCruiseStateCustom.error)} />
      ) : (
        ""
      )}
      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`}>
          <div className="active section">{passengerByCruiseStateCustom.cruise.code}</div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">{t("passenger_detail_title")}</div>
      </div>
      <br />
      <br />
      <br />
      <HeadDetail
        yacht_name={passengerByCruiseStateCustom.cruise.yacht_name}
        itinerary_name={passengerByCruiseStateCustom.cruise.itinerary_name}
        cruise_name={passengerByCruiseStateCustom.cruise.name}
        start_date={passengerByCruiseStateCustom.cruise.start_date_format}
        end_date={passengerByCruiseStateCustom.cruise.end_date_format}
      />
      <TableContainer component={Paper}>
        <Toolbar>
          <Typography className={classes.title} variant="h6" noWrap>
            {t("passenger_detail_title")} {passengerByCruiseStateCustom.message}
          </Typography>
          <Button primary onClick={handleGenerateExcel}>{t("generate_list")}</Button>
        </Toolbar>
        <Divider variant="middle" />
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {t("passenger_detail_cabin")}
              </TableCell>
              <TableCell>{t("passenger_detail_name")}</TableCell>
              <TableCell>{t("passenger_detail_identification")}</TableCell>
              <TableCell>{t("passenger_detail_country")}</TableCell>
              <TableCell align="center">{t("passenger_detail_type")}</TableCell>
              <TableCell align="center">
                {t("passenger_detail_level")}
              </TableCell>
              <TableCell align="center">
                {t("passenger_detail_gender")}
              </TableCell>
              <TableCell align="center">
                {t("passenger_detail_route")}
              </TableCell>
              <TableCell>{t("passenger_detail_agency")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {passengerByCruiseStateCustom.passengers.map((passenger, index) => (
              <TableRow key={index}>
                <TableCell align="center">{passenger.cabin_name}</TableCell>
                <TableCell>
                  <Link
                    to={`/cruises/${cruise_id}/reservations/${passenger.reservation_id}/bookings/${passenger.booking_id}/spaces/${passenger.space_id}/spacePassenger/${passenger.space_passenger_id}/passengers/${passenger.passenger_id}`}
                  >
                    {passenger.last_name.toUpperCase()} /{" "}
                    {passenger.first_name.toUpperCase()}
                  </Link>
                </TableCell>

                <TableCell>{t(passenger.identification)}</TableCell>
                <TableCell>{t(passenger.country)}</TableCell>
                <TableCell align="center">{t(passenger.cruise_type)}</TableCell>
                <TableCell align="center">{passenger.deck}</TableCell>
                <TableCell align="center">{t(passenger.gender)}</TableCell>
                <TableCell align="center">{passenger.routes !== '' ? passenger.routes : t("not defined")}</TableCell>
                <TableCell>{passenger.agency}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
